export const openInNewTab = (path: string) => window.open(path, '_blank', 'noopener,noreferrer');
